export enum LocalMessageUpdateModeType {
  // the patch is applied over the current message
  Merge = 'merge',
  // push with a known replaceKey: fields missing from the patch fall back to their defaults
  Replace = 'replace',
}
